<template>
  <el-table
    ref="singleTable"
    :data="list"
    highlight-current-row
    @current-change="handleCurrentChange"
    height="500"
    style="width: 100%;"
  >
    <el-table-column type="index" width="50"></el-table-column>
    <el-table-column property="voiceName" label="广播名称"></el-table-column>
    <!-- <el-table-column property="typeName" label="广播分组" v-if="typeName"> -->
    <!-- </el-table-column> -->
    <el-table-column property="voiceType" label="广播类型">
      <template v-slot="scope">
        {{ $store.state.select.broadcastType[scope.row.voiceType].nameOne }}
      </template>
    </el-table-column>
    <!-- <el-table-column property="areaName" label="绑定分区" v-if="areaName"> -->
    <!-- </el-table-column> -->
  </el-table>
</template>

<script>
export default {
  name: "RestBroadcastAddOrEdit",
  components: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    broadcastBrand: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      currentRow: null
    };
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.currentRow = val;
      // console.log(val);
      if (val) {
        if(this.broadcastBrand == 0) {
          this.$store.commit("updateSelectBroadcastCatalogIdTemp", val.catalogId);
        } else {
          this.$store.commit("updateSelectBroadcastCatalogIdTemp", val.fileId);
        }
        this.$store.commit("updateSelectBroadcastNameTemp", val.voiceName);
      } else {
        this.$store.commit("updateSelectBroadcastCatalogIdTemp", "");
        this.$store.commit("updateSelectBroadcastNameTemp", "");
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
